<template>
  <div class="profile-system-info">
    <info-block :title="$t('labels.system_information')"
                marker-color="#6AD1F4" hidePaddingTop>
      <div class="profile-block__row" v-if="org.getId()">
        <div class="profile-block__row-label">{{ $t('orgs.subdivision_id') }}</div>
        <div class="profile-block__row-data">{{ org.getId() }}</div>
      </div>
    </info-block>
  </div>
</template>
<script>
  import infoBlock from 'src/components/InfoBlock/InfoBlock.vue'
  import moment from 'moment'
  import {lang} from '@/lang/index'

  export default {
    props: ['org', 'date'],
    components: {
      infoBlock
    },
    methods: {
      statusToText (status) {
        switch (status) {
          case 'active':
            return this.$t('orgs.actual');
          default:
            return this.$t('orgs.archived');
        }
      }
    },
    filters: {
      dateFormatFilter: function (value) {
        if (!value) return ''
        value = value.toString()
        return moment(String(value)).locale(lang).format('DD MMM YYYY HH:mm')
      }
    }
  }
</script>